import Api from './operations';
import { types } from './types';
export function resetPassword(token, birthday, serial, secret) {
  return function(dispatch) {
    return Api.resetPassword(token, birthday, serial, secret)
      .then(response => {
        console.log(response);
        switch (response.statusCode) {
          case 200:
            dispatch(resetSuccess(response.data));
            break;
          case 404:
          case 409:
            dispatch(resetFailed(response.message));
            break;
          case 400:
            dispatch(resetFailed(response.message));
            break;
          default:
            dispatch(
              resetFailed('Could not confirm. Code:' + response.statusCode)
            );
        }
      })
      .catch(error => {
        console.log(error);
        dispatch(resetFailed('Unhandled error'));
        throw error;
      });
  };
}
export function resetSuccess(data) {
  console.log(data);
  localStorage.setItem('token', data.token);
  return { type: types.RESET_SUCCESS, token: data.token };
}
export function resetFailed(error) {
  console.log('CONFIRMATION FAILED');
  return { type: types.RESET_FAILED, error: error };
}
export function clearError() {
  console.log('CLEARING THE ERROR');
  return { type: types.CLEAR_ERROR };
}



// WEBPACK FOOTER //
// ./src/components/account/ResetPassword/ducks/actions.js